import { ButtonProps } from '../../atoms/Button';
import { TextProps } from '../../atoms/Text';
import { BorderProps } from '../../atoms/Border';
import { IconProps } from '../../atoms/Icon';
import { TextContainerProps } from '../../molecules/TextContainer';
import { TextDropDownProps } from '../../molecules/TextDropDown';
import { TextFieldProps } from '../../molecules/TextField';
import { UserSummaryProps } from '../../molecules/UserSummary';


type ButtonModalInternalProps = {
  title?: TextProps;
  button?: ButtonProps;
  border?: BorderProps;
  text?: TextProps;
  actionButton?: ButtonProps;
  cancelButton?: ButtonProps;
  userSummary?: UserSummaryProps;
  caption?: TextProps;
  beforeLabel?: TextProps;
  textContainer?: TextContainerProps;
  icon?: IconProps;
  textField?: TextFieldProps;
  afterLabel?: TextProps;
  textDropDown?: TextDropDownProps;
};

type ButtonModalPropsValues = {
  'DefaultDefault': ButtonModalInternalProps;
  'DeleteUserDestructive': ButtonModalInternalProps;
  'DisableUserDestructive': ButtonModalInternalProps;
  'EmailUpdateDefault': ButtonModalInternalProps;
  'UpdateDefault': ButtonModalInternalProps;
};

const propValues: ButtonModalPropsValues = {
  'DefaultDefault': {
    title: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Dark',
      state: 'Default',
    },
    border: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    actionButton: {
      type: 'Text',
      size: 'L',
      styleType: 'Primary',
      state: 'Default',
    },
    cancelButton: {
      type: 'Text',
      size: 'L',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'DeleteUserDestructive': {
    title: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Dark',
      state: 'Default',
    },
    border: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    userSummary: {
    },
    actionButton: {
      type: 'Text',
      size: 'L',
      styleType: 'Destructive',
      state: 'Default',
    },
    cancelButton: {
      type: 'Text',
      size: 'L',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'DisableUserDestructive': {
    title: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Dark',
      state: 'Default',
    },
    border: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    userSummary: {
    },
    caption: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body3',
    },
    actionButton: {
      type: 'Text',
      size: 'L',
      styleType: 'Destructive',
      state: 'Default',
    },
    cancelButton: {
      type: 'Text',
      size: 'L',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'EmailUpdateDefault': {
    title: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Dark',
      state: 'Default',
    },
    border: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    beforeLabel: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    textContainer: {
    },
    icon: {
      asset: 'ArrowDown',
      colour: 'IconDark',
    },
    textField: {
      state: 'Default',
      type: 'Text',
      error: 'None',
    },
    actionButton: {
      type: 'Text',
      size: 'L',
      styleType: 'Primary',
      state: 'Default',
    },
    cancelButton: {
      type: 'Text',
      size: 'L',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'UpdateDefault': {
    title: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Dark',
      state: 'Default',
    },
    border: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    beforeLabel: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    afterLabel: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Button1',
    },
    textContainer: {
    },
    icon: {
      asset: 'ArrowRight',
      colour: 'IconDark',
    },
    textDropDown: {
      state: 'Collapsed',
    },
    actionButton: {
      type: 'Text',
      size: 'L',
      styleType: 'Primary',
      state: 'Default',
    },
    cancelButton: {
      type: 'Text',
      size: 'L',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
};

const getProps = (type: string): ButtonModalInternalProps => {
  const values: ButtonModalInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
